/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
function getStyleValue(variable) {
  const root = document.querySelector(':root');
  let computedStyleRoot = getComputedStyle(root);
  let value = computedStyleRoot.getPropertyValue(variable);
  return value;
}
function setStyleValue(variable, value) {
  const root = document.querySelector(':root');
  root.style.setProperty(variable, value);
}
function getOuterHeight(el) {
  let $el = typeof el === 'string' ? document.querySelector(el) : el;
  let height = $el.clientHeight;
  height += parseInt(window.getComputedStyle($el).getPropertyValue('margin-top'));
  height += parseInt(window.getComputedStyle($el).getPropertyValue('margin-bottom'));
  return height;
}
function scrollYY() {
  if( window.pageYOffset ) { return window.pageYOffset; }
  return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
}
(function() {
  
    let navHeight = document.querySelector('.template-index .theme__header')?.clientHeight;
    let videoHeight = document.querySelector('.template-index .index-hero .video-background')?.clientHeight;
    let navOffset = videoHeight - navHeight;
    //document.querySelector('.template-index .header__wrapper').style.top = `${navOffset}px`

  
  const SIZES = {
    logoMobile: 40.37,
    logoDesktop: 40.37, 
  }
  const SELECTORS = {
    mastheadHero: '.index-hero',
    mastheadLogo: '.index-hero-logo svg',
    themeHeader: '.theme__header',
    logoMobile: '.header__mobile .logo__img--transparent',
    logoDesktop: '.header__desktop .logo__img--transparent', 
  }
  const $el = {
    mastheadHero: document.querySelector(SELECTORS.mastheadHero),
    mastheadLogo: document.querySelector(SELECTORS.mastheadLogo),
    themeHeader: document.querySelector(SELECTORS.themeHeader),
    logoMobile: document.querySelector(SELECTORS.logoMobile),
    logoDesktop: document.querySelector(SELECTORS.logoDesktop),
  }
  
  let themeHeaderHeight = getOuterHeight($el.themeHeader);
  let mastheadHeroHeight = getOuterHeight($el.mastheadHero);
  let mastheadInitialHeight = getOuterHeight($el.mastheadLogo);
  setStyleValue('--masthead-height', `${mastheadInitialHeight}px`);
  
  window.addEventListener('resize', function () {
    setStyleValue('--masthead-height', `${getOuterHeight($el.mastheadLogo)}px`);
  });
  
  document.addEventListener('scroll', function() {
    let currentLogoSize
    if (window.innerWidth < 750) {
      currentLogoSize = (1 - (scrollYY() / (mastheadHeroHeight + (4 * themeHeaderHeight)))) * mastheadInitialHeight;
      if (currentLogoSize > SIZES.logoMobile) {
        $el.mastheadLogo.style.height = `${currentLogoSize}px`;
        $el.mastheadLogo.style.opacity = 1;
        $el.logoMobile.style.opacity = 0;
      } else {
        $el.mastheadLogo.style.height = `${SIZES.logoMobile}px`;
        $el.mastheadLogo.style.opacity = 0;
        $el.logoMobile.style.opacity = 1;
      }
    } else {
      currentLogoSize = (1 - (scrollYY() / (mastheadHeroHeight + (themeHeaderHeight / 4)))) * mastheadInitialHeight;
      if (currentLogoSize > SIZES.logoDesktop) {
        $el.mastheadLogo.style.height = `${currentLogoSize}px`;
        $el.mastheadLogo.style.opacity = 1;
        $el.logoDesktop.style.opacity = 0;
      } else {
        $el.mastheadLogo.style.height = `${SIZES.logoDesktop}px`;
        $el.mastheadLogo.style.opacity = 0;
        $el.logoDesktop.style.opacity = 1;
      }
    }
    
  }); 
  
})();
